var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_5",
    "data-name": "Polygon 5",
    d: "M6.5,0,13,11H0Z",
    transform: "translate(11) rotate(90)",
    fill: "#5f6266"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmenuArrow);
export default __webpack_public_path__ + "static/media/submenu-arrow.1b08ed20d1a4223bfe088a504cbd9774.svg";
export { ForwardRef as ReactComponent };